<template>
  <el-main :style="{ height: height + 'px' }" v-loading="loading">
    <div class="Scroll_content">

      <div v-if="list.length != 0">
        <div v-for="(item, index) in list" :key="index">
          <div class="title_older">{{ item.title }}</div>
          <div class="list_content" v-for="(items, index) in item.list" :key="index">
            <div class="left_content">
              <div class="time_text">
                <div class="title_content">{{ items.subject_title }} <span v-if="items.attends_status == 1" class="qingjia">
                    ({{ $t('main.leave') }})</span></div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div class="timecontent">
                  {{ items.start_time }} - {{ items.end_time }}
                  <button
                    :class="items.status == 0 && items.mins && !items.enterStatus ? 'willStartIn' : ((items.status == 1) ? 'pending' : (items.status == 2 ? 'completed' : 'btnNone'))">
                    <span class="dot"></span>
                    {{ items.status == 0 && items.mins && !items.enterStatus ? $t('main.timeOut') + items.mins + $t('main.timeOut_1') : (items.status == 1 ? $t('main.OnAir') : (items.status == 2 ? $t('main.completed') : (items.status == 3 ? $t('main.cancel') : ''))) }}
                  </button>
                </div>
              </div>

              <el-popconfirm v-if="items.is_can_leave" :confirm-button-text="$t('main.requestLeave')"
                cancel-button-text=' ' :hide-icon="true" @confirm="handleCommand(items)">
                <el-button slot="reference"></el-button>
              </el-popconfirm>
            </div>
            <div class="content_box">

              <div class="title_content_bom">
                <div class="dom">
                  <p>{{ $t('new_test1.Level') }}</p> :&nbsp;&nbsp;<span>{{ items.level_title }}</span>
                </div>
                <div class="dom">
                  <p>{{ $t('new_test1.Topic') }}</p>
                  :&nbsp;&nbsp;<span>{{ items.lesson_topic ? items.lesson_topic : '-' }}</span>
                </div>
              </div>

              <div class="send_botton">
                <div class="bunmer presentation_preview" slot="reference" v-if="items && items.courseware_url"
                  @click="enterClassFile(items)">{{ $t('main.PresentationPreview') }}</div>
                <el-popover
                  v-if="items.attends_status == 1 || items.status == 3 || items.status == 2 || ((items.status == 0 || items.status == 1) && !items.enterStatus)"
                  placement="bottom" width="230" trigger="hover" :content="$t('main.beginToEnter')">
                  <div class="bunmers" slot="reference">{{ $t('main.enterClassRoom') }}</div>
                </el-popover>
                <div class="bunmer" slot="reference" @click="enterClassRoom(items)" v-else style="color: #FFFFFF;">
                  {{ $t('main.enterClassRoom') }}</div>
              </div>
            </div>
          </div>
          <div class="dian"></div>

        </div>
      </div>
      <NoScheduleEmpty v-else />

      <div v-if="isShoSick" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
        <div class="el-message-box">
          <div class="el-message-box__header">
            <div class="el-message-box__title center">
              {{ $t('main.sickTitle') }}
            </div>
            <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
              <i class="el-message-box__close el-icon-close"></i>
            </button>
          </div>
          <div class="el-message-box__content">
            <div class="el-message-box__container">
              <div class="el-message-box__message">
                <p class="center">{{ sickInfo }}</p>
                <div class="leaveInfo">
                  <p>{{ commandData.subject_title }}</p>
                  <p>{{ commandData.start_time }} - {{ commandData.end_time }}</p>
                  <p>{{ commandData.start_date }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="el-message-box__btns">
            <button style="background-color: #B50604;border-color: #B50604" type="button"
              class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
              <span>{{ $t('main.confirmSick') }}</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </el-main>

</template>
<script>
import { setStore, getStore, keys } from '@/store';
import { normalizeLocale, applyLocale } from '@/utils/lang';
import NoScheduleEmpty from './NoScheduleEmpty';

export default {
  components: {
    NoScheduleEmpty
  },
  data() {
    return {
      height: 100,
      searchStudentSn: '',
      Page_size: '30',
      Page_num: '1',
      list: [],
      loading: false,
      isShoSick: false,
      commandData: {},
      timing: null,
      sickInfo: ''
    }
  },
  created() {
    let height = document.body.offsetHeight - 104;
    this.height = height
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/onboarding'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
      return false
    }
    // 账户信息
    this.getBalance()
    this.timing = setInterval(() => {
      this.format_time()
      this.$forceUpdate()

    }, 1000)
  },
  methods: {
    getInfo() {
      this.$http.get(`/api/edu/getLeaveInfo?lesson_sn=${this.commandData.lesson_sn}&student_sn=${this.commandData.student_sn}`).then((res) => {
        if (res.data.code == 200) {
          this.sickInfo = res.data.data.info
          this.isShoSick = true
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    getBalance() {
      this.$http.get('/api/fund?model=lessons').then((res) => {
        if (res.data.code == 200) {
          let balanceData = res.data.data
          setStore(keys.userBalance, res.data.data)
          if (!balanceData.language) {
            console.log(navigator.language)
            var termn = normalizeLocale(navigator.language)
            this.$http.post('/api/saveMemberLang', { language: termn })
              .then((res) => {
                applyLocale(this.$i18n, termn)
              })
              .catch((error) => {
                console.log(error) // 请求失败返回的数据
              })
          }
          else if (balanceData.language) {
            applyLocale(this.$i18n, balanceData.language)
          }
          this.Book_a_course()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    /**
     * 获取预约课程列表方法
     */
    Book_a_course() {
      let _this = this;
      let children_id = getStore(keys.userProfile).last_student_sn;
      if (!children_id) {
        _this.getUser();
      } else {
        _this.get_kechen();
      }


    },
    get_kechen() {
      let _this = this;
      this.loading = true;
      let children_id = getStore(keys.userProfile).last_student_sn;
      this.$http.get('/api/memberPlanToLearner?type=1001&student_sn=' + children_id + '&time_diff=' + this.utils.timeZone() + '&pagesize=' + this.Page_size + '&page=' + this.Page_num).then((res) => {
        if (res.data.code == 200) {
          let Array_list = res.data.data
          for (let i = 0; i < Array_list.length; i++) {
            Array_list[i].list = [];
            Array_list[i].list.push(Array_list[i].data)
          }
          _this.list = Array_list
          _this.loading = false
        } else {
          _this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    /**
     * 时间格式化方法
     */
    format_time() {
      let Array_list = this.list;
      for (var i = 0; i < Array_list.length; i++) {
        var hoursRound = ''
        var minutesRound = ''
        let beg = this.utils.formatDate(Array_list[i].list[0].start_at).getTime() // 开始秒数
        let now = new Date().getTime()
        let begTime = beg - now
        if (begTime > 0 && begTime < 172800000) {
          hoursRound = Math.floor(begTime / 1000 / 60 / 60)
          minutesRound = Math.floor(begTime / 1000 / 60 % 60)
          Array_list[i].list[0].mins = hoursRound + (hoursRound > 0 ? this.$t('main.hours') : this.$t('main.hr')) + minutesRound + this.$t('main.mins')
        }
        if (begTime < 300000) { // 五分钟内才能进入教室
          Array_list[i].list[0].enterStatus = true
        }
        if (begTime > 10800000) {
          Array_list[i].list[0].sickStatus = true
        }
      }
      this.list = Array_list;
    },
    //进入课件
    enterClassFile(data) {
      window.open(data.courseware_url)
    },
    /**
     * 进入教室
     */
    enterClassRoom(dataJson) {
      this.$http.post('/api/SectionIsIn', { lesson_sn: dataJson.lesson_sn, student_sn: dataJson.student_sn }).then((res) => {

        if (res.data.code == 200) {
          if (res.data.data.is_class) {

            this.$http.post('/api/joinLive', { lesson_sn: dataJson.lesson_sn, student_sn: dataJson.student_sn }).then((res) => {
              window.open(res.data.data.url)
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
          } else {
            this.$message({
              message: res.data.data.message,
              type: 'warning'
            })
          }

        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })

    },
    handleCommand(command) {
      console.log(command, '-command')
      this.commandData = command
      this.getInfo()
    },
    /**
     * 确认请假方法
     */
    submitSick() {
      let _this = this;
      this.$http.post('/api/train/section_join', {
        lesson_sn: this.commandData.lesson_sn,
        student_sn: this.commandData.student_sn
      }).then((res) => {
        if (res.data.code == 200) {
          this.isShoSick = !this.isShoSick
          this.$notify({
            message: res.data.msg,
            duration: 0
          })

          _this.Book_a_course();
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    chooseImg() {
      this.isShoSick = !this.isShoSick
    },
    //用于首次进入更新换成数据
    getUser() {
      let _this = this;
      this.$http.get('/api/member/data').then((res) => {
        if (res.data.code == 200) {
          setStore(keys.userProfile, res.data.data)
          _this.get_kechen();
        } else {
          _this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
  },
  mounted() {

  },
  beforeDestroy() {
    /**
     * 离开该模块，利用生命周期结束定时器
     */
    if (this.timing) {
      clearInterval(this.timing);
    }
  },

}
</script>
<style lang="less" scoped>
.el-main {
  overflow: inherit;
}

.left_body_content {
  .left_nav_content {
    width: 358px;
    height: 900px;
    position: fixed;
    top: 84px;
    bottom: 0;
    background: #FCFCFF;
  }
}


.Scroll_content {
  height: 400px;

  .list_content {
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.09);
    box-shadow: 0px 4px 26.64px rgba(0, 0, 0, 0.09);
    border-radius: 9px;
    box-sizing: border-box;
    margin-top: 17px;

    .left_content {
      font-family: Sofia Pro;
      font-style: normal;
      display: flex;
      justify-content: space-between;

      .time_text {
        font-size: 20px;
        margin: 16px 0 10px 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .title_content {
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          color: #000000;
        }

        .timecontent {
          display: flex;
          align-items: center;

          button {
            margin-left: 30px;
          }
        }
      }
    }

    .content_box {
      border: 0px solid red;
      margin: 0px 16px 16px 16px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title_content_bom {
        display: flex;
        min-width: 220px;
        text-align: right;
        .dom {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          p {
            font-size: 16px;
            color: #000000;
            min-width: 40px;
          }

          span {
            font-size: 16px;
            color: #6B6B6B;
            display: block;
            min-width: 162px;
            text-align: left;
            max-width: 262px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
          }
        }
      }

      .send_botton {
        display: flex;
        margin-left: 30px;
        min-width: 100px;
        .bunmer {
          background: #B50604;
          border-radius: 8px;
          font-family: Sofia Pro;
          font-style: normal;
          font-weight: bold;
          font-size: 16px;
          line-height: 16px;
          align-items: center;
          text-align: center;
          color: #B50604;
          margin-top: 16px;
          cursor: pointer;
          padding: 10px 16px;
          //强制不换行
          white-space: nowrap;
        }
      }
    }

    /deep/ .el-dropdown {
      width: 37px;
      height: 37px;

      border-radius: 6px;
      margin-right: 40px;
      margin-top: 20px;

      .rightHead {
        border: none;
        font-size: 32px;
        padding: 0;

        span {
          i {

            width: 37px;
            height: 37px;
            transform: rotateY(90deg);
          }

          img {
            width: 37px;
            height: 37px;
          }
        }

      }
    }
  }
}

.title_older {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #000000;
  margin-top: 18px;
}

.qingjiaka {
  border: 0px solid red;
  width: 13px;
  position: relative;
  right: 15px;
  cursor: pointer;
}

.list_icon {
  width: 5.52px;
  height: 5.52px;
  display: block;
  margin-top: 5px;

}

.sqjiax {
  cursor: pointer;
  font-size: 24px;
  font-family: Sofia Pro-Regular;
}

.bunmers {
  padding: 10px 16px;
  height: 36px;
  background: #C9C9C9;
  border-radius: 8px;
  font-family: Sofia Pro;
  font-style: normal;
  font-size: 16px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  cursor: pointer;
  box-sizing: border-box;
  //强制不换行
  white-space: nowrap;
}

.cor {
  color: #FF6440 !important;
}

.cod {
  color: #009A91 !important;
}

.qingjia {
  color: red;
}

.icon_winm {
  position: relative;
  top: -2px;
  margin-right: 17px;
}

.el-message-box__btns button {
  height: 50px;
  background: #4B69FE;
  border-radius: 50px;
  border: none;
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 45px;
  cursor: pointer;
}

.el-message-box {
  background: #fff;

  .el-message-box__header {
    padding: 20px 0;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    box-shadow: inset 0px -1px 0px #F0F0F0;

    .el-message-box__title {
      font-size: 16px;
    }
  }

  .el-message-box__content {
    padding-top: 0;

    .el-message-box__message {
      padding-left: 0;

      p {
        font-size: 16px;
      }

      >p {
        margin: 24px 0 16px;
      }
    }
  }

  .el-message-box__btns {
    box-shadow: inset 0px 1px 0px #F0F0F0;
    margin: 0;
    padding: 10px 15px 0;

    button {
      margin: 0;
      box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
      border-radius: 2px;
      font-size: 14px;
      font-weight: 700;
    }
  }
}

.leaveInfo {
  display: flex;
  justify-content: center;
  margin: 16px auto 20px;

  p {
    color: #969696;
    font-size: 16px;
    border-right: 1px solid #969696;
    padding: 0 10px;

    &:nth-child(3n) {
      border: none;
    }
  }
}

.el-message-box__wrapper .el-message-box__btns button {
  width: 203px;
}

/deep/ .el-button.el-popover__reference {
  padding: 0;
  width: 22px;
  height: 30px;
  border: none;
  background: url('../../assets/more.svg');
  border-radius: 6px;
  margin-right: 16px;
  margin-top: 16px;

  // &:focus {
}

.presentation_preview {
  margin-right: 24px;
  background-color: #fff !important;
  border: 2px solid #b50604 !important;
  color: #b50604 !important;
  height: 36px !important;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/children/AttendClassNow.vue